import { PERMISSION_KEYS } from '../constants';
import { CASCADE_BEHAVIORS, RULE_TYPES } from './rules.config';
import { removeKeyFromTargetList } from '../utils/ruleTargetHelpers';

export const RULE_OVERRIDES_BY_DOMAIN = {
  cche: {
    [RULE_TYPES.LOCK_WHEN_CHECKED]: {
      remove: [
        {
          trigger: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_RELATIONSHIPS,
          target: PERMISSION_KEYS.RELATIONSHIPS.DEASSOCIATE_B2B_RELATIONSHIP,
        },
        {
          trigger: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_NOTES,
          target: PERMISSION_KEYS.NOTES.CLONE_NOTES,
        },
      ],
    },
    [RULE_TYPES.SPECIAL_CONDITION]: {
      removeTargets: [PERMISSION_KEYS.NOTES.CLONE_NOTES],
    },
    [RULE_TYPES.MANAGE_USERS]: {
      override: {
        behavior: CASCADE_BEHAVIORS.STRICT_CASCADE,
        checkThreshold: undefined,
      },
    },
  },
};

export function applyDomainRuleOverrides(rules, domain) {
  const overridesForDomain = RULE_OVERRIDES_BY_DOMAIN[domain];
  if (!overridesForDomain) return rules;

  const resolved = { ...rules };

  Object.entries(overridesForDomain).forEach(([ruleType, override]) => {
    const ruleConfig = resolved[ruleType];
    if (!ruleConfig) return;

    if (override.override) {
      resolved[ruleType] = { ...ruleConfig, ...override.override };
      return;
    }

    if (override.removeTargets) {
      if (!ruleConfig.targets) return;
      const targets = { ...ruleConfig.targets };
      override.removeTargets.forEach((key) => {
        delete targets[key];
      });
      resolved[ruleType] = { ...ruleConfig, targets };
      return;
    }

    if (override.remove) {
      if (!ruleConfig.targets) return;
      const targets = { ...ruleConfig.targets };
      override.remove.forEach(({ trigger, target }) => {
        if (!targets[trigger]) return;
        const filteredList = removeKeyFromTargetList(targets[trigger], target);
        if (filteredList.length === 0) {
          delete targets[trigger];
        } else {
          targets[trigger] = filteredList;
        }
      });
      resolved[ruleType] = { ...ruleConfig, targets };
    }
  });

  return resolved;
}
